import createStore from './create';
import { reducers, initialState } from './reducers';

const store = createStore(reducers, initialState);

export type Store = typeof store;
export type StoreState = ReturnType<Store['getState']>;

export default store;
